var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRenter = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23.762 25.5H7v-2.095a5.238 5.238 0 0 1 5.238-5.238h6.286a5.238 5.238 0 0 1 5.238 5.238V25.5Zm-8.381-9.429a6.287 6.287 0 0 1-5.807-8.69 6.286 6.286 0 1 1 5.807 8.69Z",
  fill: "#697077"
})));
export default SvgRenter;